import React from "react";
import { Link } from "react-router-dom";
import Face from "../../Shared/SvgIcons/Face";
import SpeedMeter from "../../Shared/SvgIcons/SpeedMeter";
import Star from "../../Shared/SvgIcons/Star";
import Bid from "./Bid";
import Details from "./Details";

const detailsData = {
  Odometer: "167,121",
  Colour: "Silver",
  Transmission: "Automatic",
  Engine: "6 Cyl 3.8L",
  "Body Type": "Station Wagon",
  Fuel: "Petrol",
};

const ListViewCard = () => {
  return (
    <div className="box-border flex overflow-hidden border border-lightGray">
      <picture className="aspect-square h-40 grow ">
        <img
          src="/assets/images/products/product1.png"
          alt=""
          className="aspect-square w-full"
        />
      </picture>

      <div className="flex grow items-end justify-between px-8 pt-8 pb-4">
        <div>
          <Link to="/auctionlisting">
            <h3 className="font-pop text-xl font-bold">Mbomile City</h3>
          </Link>
          <div className="mt-4 mb-1.5 flex items-end gap-1 font-pop text-xs font-normal text-cardSecondaryColor">
            <SpeedMeter className="inline-block h-4 w-4" />
            <span>21,000km -</span>
            <span>2018</span>
          </div>
          <div className="mb-3.5 font-pop text-xs text-cardSecondaryColor">
            <span>Pretoria in Gauteng</span> <span>1 week ago</span>
          </div>
          <Details details={detailsData} />
        </div>
        <div className="flex flex-col ">
          <p className="flex items-center gap-3 font-pop text-xs font-medium">
            <Face className="h-5 w-5 cursor-pointer" />
            <span className="leading-6">
              Ben88 <span className="text-primary">(66)</span>
            </span>
          </p>
          <p className="flex items-center gap-3 font-pop text-xs font-medium">
            <Star className="h-5 w-5 cursor-pointer" />
            <span className="leading-6">Watch this </span>
          </p>
        </div>
      </div>
      <Bid />
    </div>
  );
};

export default ListViewCard;
